import { LazyLoadImage } from "react-lazy-load-image-component";
import { styled } from "styled-components";

import { CheckboxInput } from "components/atoms/Checkbox/Checkbox.styled";
import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const ButtonContainer = styled.div`
    display: flex;
    gap: 1rem;
    position: relative;
    bottom: 1rem;
    left: 50%;
    padding: 1rem;
    transform: translateX(-50%);
`;

export const StyledLazyLoadImage = styled(LazyLoadImage)<{
    isSelected: boolean;
}>`
    border: ${({ isSelected }) =>
        isSelected ? `0.2rem solid ${colourScheme.error}` : "none"};
    border-radius: 0.5rem;
`;

export const ImageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
    align-items: center;
    position: relative; /* Ensure relative positioning */

    &:hover ${CheckboxInput} + label::before {
        opacity: 1;
    }

    &:hover ${CheckboxInput}:checked + label::before {
        background: ${colourScheme.error};
    }

    & > a {
        text-align: center;
    }
`;

export const ImageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: relative;

    & img {
        border-radius: 0.5rem;
        width: 100%;
        max-width: 100vw;
        ${device.md} {
            max-width: 50vw;
        }
        object-fit: contain;
        height: auto;
        max-height: none;
    }
`;

export const ImageGridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-gap: 1rem;
    align-content: start;
    align-items: start;
    justify-content: start;
    width: 100%;
    height: auto;
    & img {
        border-radius: 0.5rem;
        width: 100%;
        object-fit: cover;
        height: auto;
        max-height: 100%;
        grid-column: auto;
        grid-row: auto;
    }
`;
